export const TypeOperation = [
    { id: 1, nombre: "Estándar" },
    { id: 2, nombre: "AIU" },
    { id: 3, nombre: "Mandatos" },
    { id: 4, nombre: "Transporte" },
    { id: 5, nombre: "Cambiario" },
    { id: 6, nombre: "CUFE" },
    { id: 7, nombre: "CUDE" },
    { id: 8, nombre: "POS" },
    { id: 9, nombre: "SNum" },
    { id: 10, nombre: "Recaudo" },
    { id: 11, nombre: "Reporte" },
    { id: 12, nombre: "SinAporte" },
    { id: 13, nombre: "Nota Crédito que referencia una factura electrónica." },
    { id: 14, nombre: "Nota Crédito sin referencia a facturas." },
    { id: 15, nombre: "Nota Débito que referencia una factura electrónica." },
    { id: 16, nombre: "Nota Débito sin referencia a facturas." },
    { id: 17, nombre: "Estándar" },
    { id: 18, nombre: "AIU" },
    { id: 19, nombre: "Mandatos" },
    { id: 20, nombre: "Transporte" },
    { id: 21, nombre: "Cambiario" },
    { id: 22, nombre: "CUFE" },
    { id: 23, nombre: "CUDE" },
    { id: 24, nombre: "POS" },
    { id: 25, nombre: "SNum" },
    { id: 26, nombre: "Recaudo" },
    { id: 27, nombre: "Reporte" },
    { id: 28, nombre: "SinAporte" },
    { id: 29, nombre: "Nota Crédito que referencia una factura electrónica." },
    { id: 30, nombre: "Nota Crédito sin referencia a facturas." },
    { id: 31, nombre: "Nota Débito que referencia una factura electrónica." },
    { id: 32, nombre: "Nota Débito sin referencia a facturas." }
  ];

  export const TypeDocuments = [
    { id: 1, nombre: "Registro civil" },
    { id: 2, nombre: "Tarjeta de identidad" },
    { id: 3, nombre: "Cédula de ciudadanía" },
    { id: 4, nombre: "Tarjeta de extranjería" },
    { id: 5, nombre: "Cédula de extranjería" },
    { id: 6, nombre: "NIT" },
    { id: 7, nombre: "Pasaporte" },
    { id: 8, nombre: "Documento de identificación extranjero" },
    { id: 9, nombre: "PEP" },
    { id: 10, nombre: "NIT de otro país" },
    { id: 11, nombre: "NUIP *" },
    { id: 12, nombre: "Registro civil" },
    { id: 13, nombre: "Tarjeta de identidad" },
    { id: 14, nombre: "Cédula de ciudadanía" },
    { id: 15, nombre: "Tarjeta de extranjería" },
    { id: 16, nombre: "Cédula de extranjería" },
    { id: 17, nombre: "NIT" },
    { id: 18, nombre: "Pasaporte" },
    { id: 19, nombre: "Documento de identificación extranjero" },
    { id: 20, nombre: "PEP" },
    { id: 21, nombre: "NIT de otro país" },
    { id: 22, nombre: "NUIP *" }
  ];

  export const TypeLiabilities = [
    { id: 1, nombre: "Gran contribuyente" },
    { id: 2, nombre: "Autorretenedor" },
    { id: 3, nombre: "Agente de retención IVA" },
    { id: 4, nombre: "Régimen simple de tributación" },
    { id: 5, nombre: "No aplica – Otros" }
  ];

  export const TaxDetail= [
    { id: 1, nombre: "IVA" },
    { id: 2, nombre: "INC" },
    { id: 3, nombre: "IVA e INC" },
    { id: 4, nombre: "No aplica" }
  ]

  